import { translate } from '@cashfree-intl/coherent';
import * as Yup from 'yup';

const message = {
  required: `${translate('this_is_a_required_field')}`,
};

export const emailLoginSchema = Yup.object({
  email: Yup.string()
    .email(`${translate('incorrect_email_address')}`)
    .required(message.required),
  password: Yup.string()
    .required(message.required)
    .trim(),
});

export const aliasLoginSchema = Yup.object({
  accountAlias: Yup.string()
    .required(message.required)
    .trim(),
  username: Yup.string()
    .required(message.required)
    .trim(),
  password: Yup.string()
    .required(message.required)
    .trim(),
});
